import axios from 'axios';
export async function getIsTokenizationEnabled() {
    const response = await axios.get('/api/coin/enabled');
    return response.data;
}
